

import Promotion from "@core/Promotion.js";
import {$date, $util} from "@util/util.js";

export default class Subscribe extends Promotion{
    constructor(){
        super();

        this._leftTime = "";
        this._desc = "";

        // this._currentTime = _engine._currentTime;
    }

    //距预约开始还有: reservationStartTime - engine.current
    //距预约结束还有：reservationEndTime - engine.current
    //如果某个阶段时间差为0，刷新整个页面

    init(data){
        this._id = data.id;
        this._name = "预约";
        this._type = data.type;
        this._startTime = data.startTime;
        this._endTime = data.endTime;
        this._reservationStartTime = data.reservationStartTime;
        this._reservationEndTime = data.reservationEndTime;
        this._inBuyTime = data.inBuyTime;
        this._purchaseCeiling = data.purchaseCeiling;
        this._isCanScribe = false;
        this._showPriceTime = data.showPriceTime;// 价格公布时间

        this.tick();
    }

    getLeftInfo(){
        if($date.equalTime(this._currentTime, this._reservationStartTime)){
            window.location.href = window.location.href;
        }
        if($date.equalTime(this._currentTime, this._reservationEndTime)){
            window.location.href = window.location.href;
        }
        // 价格公布时间
        if(this._showPriceTime && $date.equalTime(this._currentTime, this._showPriceTime)){
            window.location.href = window.location.href;
        }
        let bl = $date.compareData(this._currentTime, this._reservationStartTime);
        if(bl){
            this._desc = '距预约结束还剩';
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._reservationEndTime);
            this._isCanScribe = true;
        }else{
            this._desc = '';
            this._leftTime = '';
            // this._desc = '距预约开始';
            // this._leftTime = $util.countDown.doCountDown(this._currentTime, this._reservationStartTime);
        }
        // this._currentTime = this._currentTime + 1000;
    }

    tick(){
        const nowDate = new Date();
        this._currentTime = nowDate.getTime()+_engine._timeDiff;
        this.getLeftInfo();      
        window.setInterval(()=>{
            const nowDate = new Date();
            this._currentTime = nowDate.getTime()+_engine._timeDiff;
            this.getLeftInfo();        
        },1000)
    }
}